import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { AdxBookingPassenger } from '../models/adx-booking-passenger.model';

@Injectable({
  providedIn: 'root'
})
export class AdxBookingPassengerService {
  private resourcePath: string = 'dbov2/passenger';

  constructor(private httpClient: HttpClient) {}

  getPassengersByBookingId(bookingId: number): Observable<AdxBookingPassenger[]> {
    return this.httpClient
      .get<AdxBookingPassenger[]>(`${this.resourcePath}/booking/${bookingId}`)
      .pipe(catchError(this.errorHandler));
  }

  errorHandler(error: HttpErrorResponse) {
    return throwError(() => new Error(error.message || 'Server Error'));
  }
}
